/**
 * React-Query keys for the clean SEPA subsystem.
 *
 * Mirrors the structure of `transaction.keys.ts` so invalidation stays predictable:
 * every hook derives its key from here, never inline literals.
 */
export const sepaKeys = {
  bankAccounts: {
    all: ["sepa", "bankAccounts"] as const,
    forPatient: (patientId: number) => ["sepa", "bankAccounts", "patient", patientId] as const,
  },
  transactions: {
    all: ["sepa", "transactions"] as const,
    list: (filters: Record<string, unknown>) => ["sepa", "transactions", "list", filters] as const,
  },
  exportBatches: {
    all: ["sepa", "exportBatches"] as const,
    list: (filters: Record<string, unknown>) => ["sepa", "exportBatches", "list", filters] as const,
    detail: (id: string) => ["sepa", "exportBatches", "detail", id] as const,
  },
};
